(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
(function () {

  function HeroVolume(sectionId) {
    var self = this;
    self.sectionId   = sectionId;
    self.isMuted     = true;
    self.initialized = false;

    self.btn          = document.querySelector('[data-hero-volume-btn="'           + sectionId + '"]');
    self.slider       = document.querySelector('[data-hero-volume-slider="'        + sectionId + '"]');
    self.sliderWrapper = document.querySelector('[data-hero-volume-slider-wrapper="' + sectionId + '"]');

    var wrappers = document.querySelectorAll('[data-hero-video-wrapper="' + sectionId + '"]');
    self.videos  = [];
    wrappers.forEach(function (w) {
      var v = w.querySelector('video');
      if (v) self.videos.push(v);
    });

    if (!self.btn || !self.slider || !self.sliderWrapper || self.videos.length === 0) return;

    self.defaultVolume = parseFloat((wrappers[0] && wrappers[0].dataset.defaultVolume) || '0.5');

    // Ensure all videos start muted with volume pre-set
    self.videos.forEach(function (v) {
      v.volume = self.defaultVolume;
      v.muted  = true;
    });

    self.btn.addEventListener('click',    function () { self._onBtnClick(); });
    self.slider.addEventListener('input', function () { self._onSliderInput(); });

    self.initialized = true;
  }

  HeroVolume.prototype._updateUI = function (muted) {
    if (muted) {
      this.btn.removeAttribute('data-unmuted');
      this.btn.setAttribute('aria-label', 'Unmute video');
      this.sliderWrapper.classList.remove('is-visible');
    } else {
      this.btn.setAttribute('data-unmuted', '');
      this.btn.setAttribute('aria-label', 'Mute video');
      this.sliderWrapper.classList.add('is-visible');
    }
  };

  HeroVolume.prototype._applyMute = function () {
    this.isMuted = true;
    this.videos.forEach(function (v) { v.muted = true; });
    this._updateUI(true);
  };

  /*
   * _applyUnmute — the heart of the fix.
   *
   * Browsers (Chrome, Safari, Firefox) enforce an autoplay policy:
   * a video that started as muted-autoplay cannot simply have .muted set
   * to false — the browser will silently ignore the audio.
   *
   * The only reliable cross-browser solution is:
   *   1. Set .muted = false  AND  .volume > 0
   *   2. Call .play() again immediately, inside the same user-gesture
   *      call stack (i.e. synchronously from the click handler).
   *
   * If the browser still blocks it (e.g. low-power mode, strict policy),
   * the .play() Promise rejects and we gracefully fall back to muted.
   */
  HeroVolume.prototype._applyUnmute = function (vol) {
    var self = this;

    // If slider is at 0 or undefined, snap to default so unmute is audible
    if (!vol || vol <= 0) {
      vol = self.defaultVolume;
      self.slider.value = Math.round(vol * 100);
    }

    self.isMuted = false;
    self._updateUI(false);

    self.videos.forEach(function (v) {
      v.muted  = false;
      v.volume = vol;

      /*
       * .play() must be called synchronously inside the user-gesture handler.
       * This is what tells the browser "the user asked for audio".
       * Without this call the audio stays silenced even if .muted = false.
       */
      var promise = v.play();
      if (promise !== undefined) {
        promise.catch(function () {
          /*
           * Browser rejected the play-with-audio request.
           * Fall back silently to muted so the video keeps running.
           */
          v.muted = true;
          self.isMuted = true;
          self._updateUI(true);
        });
      }
    });
  };

  HeroVolume.prototype._onBtnClick = function () {
    if (this.isMuted) {
      this._applyUnmute(parseFloat(this.slider.value) / 100);
    } else {
      this._applyMute();
    }
  };

  HeroVolume.prototype._onSliderInput = function () {
    var vol = parseFloat(this.slider.value) / 100;
    if (vol <= 0) {
      this._applyMute();
    } else {
      /*
       * Update volume on all videos regardless of mute state.
       * If currently muted, also unmute — the slider drag IS the gesture.
       */
      this.videos.forEach(function (v) { v.volume = vol; });
      if (this.isMuted) {
        this._applyUnmute(vol);
      }
    }
  };

  /* ── Bootstrap ── */
  function init(sectionId) {
    new HeroVolume(sectionId);
  }

  function boot(sectionId) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(sectionId); });
    } else {
      init(sectionId);
    }
  }

  boot('{{ section.id }}');

  // Re-init when Shopify theme editor reloads the section
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('#Hero-{{ section.id }}')) {
      init('{{ section.id }}');
    }
  });

}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
